import { button, el } from './dom.js';

interface LegendRow {
  readonly swatch: HTMLElement;
  readonly label: string;
}

const swatch = (color: string, marker?: string): HTMLElement => {
  const box = el('div', {
    className: 'legend-swatch',
    attrs: { style: `background:${color}` },
  });
  if (marker) {
    const m = el('span', { className: 'legend-marker', text: marker });
    box.appendChild(m);
  }
  return box;
};

const speckled = (): HTMLElement => el('div', { className: 'legend-swatch legend-speckled' });

const lockedSwatch = (): HTMLElement => el('div', { className: 'legend-swatch legend-locked' });

const row = (item: LegendRow): HTMLElement =>
  el('div', {
    className: 'legend-row',
    children: [item.swatch, el('span', { className: 'legend-text', text: item.label })],
  });

const buildPickerRow = (): HTMLElement => {
  const bar = el('div', { className: 'legend-picker' });
  ['#F28B82', '#CE93D8', '#90CAF9', '#A5D6A7', '#FFCC80'].forEach((c) => {
    const dot = el('div', { className: 'legend-picker-dot', attrs: { style: `background:${c}` } });
    bar.appendChild(dot);
  });
  return bar;
};

const labelSwatch = (text: string, bg: string, fg: string): HTMLElement => {
  const box = el('div', {
    className: 'legend-swatch legend-pill',
    attrs: { style: `background:${bg};color:${fg}` },
    text,
  });
  return box;
};

const buildLegend = (): HTMLElement =>
  el('div', {
    className: 'legend',
    children: [
      row({ swatch: labelSwatch('START', '#ffffff', '#1a1d29'), label: 'Your start cell' }),
      row({ swatch: labelSwatch('GOAL', '#fde047', '#1a1d29'), label: 'The goal cell' }),
      row({
        swatch: buildPickerRow(),
        label: 'Tap a color from the bar — every cell in your region flips over to that color',
      }),
      row({ swatch: swatch('#90CAF9'), label: 'Or tap any cube on the board to pick its color' }),
      row({ swatch: lockedSwatch(), label: '╳ Locked: never changes color' }),
      row({ swatch: speckled(), label: '• Penalty: -1 move when first reached' }),
    ],
  });

export const showFullHelp = (parent: HTMLElement): void => {
  const close = (): void => {
    if (root.parentElement) root.parentElement.removeChild(root);
  };

  const card = el('div', {
    className: 'overlay-card help-card',
    children: [
      el('h1', { text: 'How to play' }),
      el('p', {
        className: 'lead',
        text: 'Pick colors to flood the connected region around the white halo until it touches the gold halo. Beat each level within the move budget.',
      }),
      buildLegend(),
      el('p', {
        className: 'tip',
        text: 'Tip: tap a color in the bar OR tap any cube on the board to pick that color.',
      }),
      button('Got it', 'big-btn', close),
    ],
  });

  const root = el('div', { className: 'overlay', children: [card] });
  parent.appendChild(root);
};
